//#region : Imports

import { Component, OnInit } from "@angular/core";

import * as moment from "moment";

import { Howl, Howler } from "howler";

import { GlobalsService } from "../globals.service";
import { MapViewComponent } from "../components/mapview/mapview.component";

//#endregion

declare var $: any;
declare var jQuery: any;

@Component({
  selector: "app-aside",
  templateUrl: "./aside.component.html",
  styleUrls: ["./aside.component.css"],
})
export class AsideComponent implements OnInit {
  //Locals
  private time;
  private doLogin: boolean = false;
  private synced: boolean = true;
  private topIncidentId: string = undefined;
  private emptyIncidentText: string = "Loading incidents";
  private refreshTimer: any = null;
  private alarmSound: any;
  private loginTimer: any = null;
  private dangerColorMap: string[] = [
    "#ed1c24",
    "#007e92",
    "#007e92",
    "#007e92",
    "#007e92",
    "#007e92",
    "#007e92",
    "#007e92",
    "#007e92",
    "#007e92",
  ];
  public incidentList: any = [];
  private deviceMap: Map<string, any> = new Map();
  public static instance;

  constructor(private globals: GlobalsService) {
    AsideComponent.instance = this;

    // Setup the new Howl
    this.alarmSound = new Howl({
      src: ["assets/sound/woop_woop.mp3"],
    });

    //#region : Background processes

    //Initial draw of the incidents
    this.globals.deviceList(
      undefined,
      undefined,
      undefined,
      undefined,
      (devices: any) => {
        //#region : Build the device map

        if (devices && Array.isArray(devices)) {
          for (var i = 0; i < devices.length; i++) {
            //Get the device info
            let dev = devices[i];
            let snr = dev.snr;

            this.deviceMap.set(snr, dev);
          }
        }

        //#endregion

        this.refreshIncidents(false, false, () => {});
      }
    );

    //Login
    this.loginTimer = setInterval(() => {
      this.doLogin = true;
    }, 60000 * 10);

    //Refresh incidents
    // this.refreshTimer = setInterval(() => {
    // this.refreshIncidents(this.doLogin);
    // this.doLogin = false;
    // }, 15000);

    //#endregion

    // });
  }

  ///Drawer
  private unreadAlerts: boolean = false;
  public mapDrawerIsClosed: boolean = false;

  public toggleSidebar() {
    this.mapDrawerIsClosed = !this.mapDrawerIsClosed;
  }
  ///Drawer

  ngOnInit(): void {}

  ngAfterViewInit() {}

  clearIncidents() {
    this.incidentList = [];
    this.topIncidentId = undefined;
    this.doLogin = true;
  }

  getDeviceName(snr: string) {
    let device: any = this.deviceMap.get(snr);

    if (device && device.name) {
      return device.name;
    } else {
      return "";
    }
  }

  refreshIncidents(
    login: boolean = false,
    playSound: boolean = true,
    onDone?: () => void
  ) {
    //Setup the time
    let from = new Date();
    from.setDate(from.getDate() - 2);
    // from.setHours(0, 0, 0, 0);
    let to = new Date();
    to.setHours(23, 59, 59, 999);

    //Do login?
    if (this.globals.currentView == "dashboard") {
      if (login) {
        this.globals.containerLogin(
          () => {
            this.globals.syncStatus = "Syncing";

            //Get the incidents for today
            this.globals.incidentList(
              from,
              to,
              this.topIncidentId,
              undefined,
              (incidents: any) => {
                this.drawIncidentLog(incidents, false, playSound);
                this.syncStatus(true);

                if (onDone) onDone();
              },
              () => {
                this.syncStatus(false);
              },
              true
            );
          },
          () => {
            this.syncStatus(false);
          },
          true
        );
      } else {
        this.globals.incidentList(
          from,
          to,
          this.topIncidentId,
          undefined,
          (incidents: any) => {
            this.drawIncidentLog(incidents, false, playSound);
            this.syncStatus(true);
          },
          () => {
            this.syncStatus(false);
          },
          true
        );
      }
    }
  }

  syncStatus(success: boolean) {
    this.synced = success;

    if (success) {
      this.emptyIncidentText = "No incidents (past 48 hours)";

      this.globals.syncStatus = "Sync OK";
      this.globals.syncTime = moment().format(this.globals.dateTimeFormat);
    } else {
      this.emptyIncidentText = "Connection failure";

      this.globals.syncStatus = "Sync Failure";
      this.globals.syncTime = moment().format(this.globals.dateTimeFormat);
    }
  }

  drawIncidentLog(
    incidents: any,
    clear: boolean = false,
    playSound: boolean = true
  ) {
    //Clear the log?
    if (clear) this.incidentList = [];

    if (incidents && Array.isArray(incidents)) {
      //New alarms received?
      if (playSound && incidents.length > 0) {
        this.alarmSound.play();
      }

      for (var i = incidents.length - 1; i >= 0; i--) {
        let incident = incidents[i];
        let mapIncident = {
          data: undefined,
          timestamp: undefined,
          title: undefined,
          message: undefined,
          priority: undefined,
        };

        if (i == 0) this.topIncidentId = incident.id;

        //Setup the incident object
        mapIncident.data = incident;
        mapIncident.timestamp = moment(incident.created).format(
          this.globals.dateTimeFormat
        );
        mapIncident.title = `${incident.name}`;
        mapIncident.message = incident.message;
        mapIncident.priority = incident.priority;

        this.incidentList.splice(0, 0, mapIncident);

        // this.incidentList.push(mapIncident);
      }
    }
  }

  getIncidents() {
    return this.incidentList.filter((x) => {
      if (!x.data.expanded) x.data.expanded = false;

      return x;
    });
  }

  getColorByPriority(priority: number) {
    //Limit the priority
    if (priority < 0) priority = 0;
    if (priority > this.dangerColorMap.length - 1)
      priority = this.dangerColorMap.length - 1;

    //Return the color
    return this.dangerColorMap[priority];
  }

  showIncidentMarker(incident: any) {
    let snr = incident.data.snr;
    this.globals.deviceGetBySnr(incident.data.snr, (device: any) => {
      if (device && device.state && device.state.position) {
        let loc = device.state.position;

        MapViewComponent.goto(loc.latitude, loc.longitude, snr);
      } else {
        this.globals.showWarningAlert(
          "Locate Incident",
          "There are no location information associated with this device."
        );
      }
    });
  }
}
